<template>
  <li class="accordion-item no-sales-order-new-card">
    <a
      class="item-content"
      href="#"
    >
      <div class="no-sales-order-new-card__box">
        <div class="display-flex">
          <section class="no-sales-order-new-card__delete">
            <f7-button @click="emit('deleteLine', selectedLine)">
              <img src="@/static/icons/ic_delete_02.svg">
            </f7-button>
          </section>

          <section class="no-sales-order-new-card__info">
            <div class="no-sales-order-new-card__info__client">
              {{ selectedLine.Cliente.Nombre || '' }}
            </div>

            <div class="no-sales-order-new-card__info__address">
              {{ selectedLine.Direccion.Nombre || '' }}
            </div>

            <div class="no-sales-order-new-card__info__article">
              {{ selectedLine.Producto.Nombre || '' }} - {{ selectedLine.Producto.Codigo || '' }}
            </div>
          </section>

          <section class="no-sales-order-new-card__qr">
            <f7-button @click="onQrClick">
              <img src="@/static/icons/ic_qr.svg">
            </f7-button>
          </section>
        </div>
        <div class="no-sales-order-new-card__content-stepper">

          <span>{{ t('common.quantity') }}</span>
          <div
            class="stepper stepper-fill stepper-init"
          >
            <f7-stepper
              fill
              :value="Number(selectedLine.CantidadTotalPales)"
              :min="0"
              :max="100000000"
              @input="selectedLine.CantidadTotalPales = $event.target.value"
              @stepper:change="changeNumPallets"
            />
          </div>
        </div>
      </div>
    </a>
    <div
      v-if="selectedLine.Desglose.length > 0"
      class="item-content-after item-link"
    >
      <span>{{ t('commercialization.common.loadedPallets') }} ({{ selectedLine.Desglose.length }}) </span>
      <img
        src="@/static/icons/ic_arrow_down_1.svg"
        alt="iconDown"
        width="17px"
      >
    </div>

    <div class="accordion-item-content">
      <div class="list content-pallets">
        <ul>
          <li
            v-for="(item, index) in selectedLine.Desglose"
            :key="index"
          >
            <div
              v-if="item.UnidadContenedora"
              class="item-inner"
            >
              <div class="item-title">
                {{ item.UnidadContenedora.CodigoBarrasPale || item.UnidadContenedora.NumeroSerie }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <UCCodeScanner
      ref="codeScannerRef"
      :continuous-bar-code-reading="true"
      :allow-manual-code-entry="true"
      :autofocus-on-input="introduccionManualCBLecturaPalesExpeciones"
      :fab-button-show="false"
      :open-information-bar="infoSheetParams.opened"
      :title="infoSheetParams.title"
      :subtitle1="infoSheetParams.subtitle1"
      :state="infoSheetParams.state"
      @code-reading="onBarcodeReading"
      @codigo-barras="onBarcodeReading"
      @numero-serie="onSerialNumberReading"
    />
  </li>
</template>

<script setup>
// @ts-check
import {
  reactive,
  ref,
  shallowRef,
  toRefs,
} from 'vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  HiDialog,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { useI18n } from 'vue-i18n';
import { useParamRef } from '@erpagroapp/params';
import APIErp from '@/js/services/APIErp';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';

/** @import { PropType, Ref, ShallowRef } from 'vue' */
/**
 * @import {
 * InfoSheetState,
 * Respuesta,
 * UnidadContenedora,
 * } from '@erpagroapp/types' */

const props = defineProps({
  selectedLine: {
    // TODO: This should be `PropType<LineaExpedicion | null>`
    type: /** @type {PropType<Record<string, any>>} */ (Object),
    default: null,
  },
});

const emit = defineEmits(['deleteLine']);

const { t } = useI18n();
const { selectedLine } = toRefs(props);

/** @type {ShallowRef<InstanceType<typeof UCCodeScanner> | null>} */
const codeScannerRef = shallowRef(null);

const infoSheetParams = reactive({
  opened: false,
  subtitle1: '',
  title: '',
  /** @type {InfoSheetState} */
  state: 'CAUTION',
});

/** @type {Ref<boolean>} */
const movePalletFromOtherLoadingOrder = ref(false);
/** @type {Ref<boolean>} */
const deleteReservesPaleFromOtherOrder = ref(false);

const introduccionManualCBLecturaPalesExpeciones = useParamRef('IntroduccionManualCBLecturaPalesExpeciones');
const lecturaContinuaCargasExpediciones = useParamRef('LecturaContinuaCargasExpediciones');
const eliminarReservaAnteriorExpediciones = useParamRef('EliminarReservaAnteriorExpediciones');
const permitirMoverPalesReservadosEnOrdenCarga = useParamRef('PermitirMoverPalesReservadosEnOrdenCarga');

async function onQrClick() {
  if (!codeScannerRef.value) {
    return;
  }

  codeScannerRef.value.Open();
  /* await sleep(200);
  codeScannerRef.value.SetFocusOnInputElement(); */
}

/**
 * @param {number} numPalets
 * @returns {void}
 */
function changeNumPallets(numPalets) {
  selectedLine.value.CantidadTotalPales = numPalets;
}

/**
 * @param {boolean} correcto
 * @param {string} mensaje
 * @param {number} [timeToDisplay]
 * @returns {Promise<void>}
 */
async function ShowInfoPale(correcto, mensaje, timeToDisplay = 1500) {
  infoSheetParams.subtitle1 = mensaje;
  if (correcto) {
    infoSheetParams.title = t('common.information');
    infoSheetParams.state = 'ENTER';
  } else {
    infoSheetParams.title = t('common.incidence');
    infoSheetParams.state = 'ERROR';
  }

  infoSheetParams.opened = true;
  await sleep(timeToDisplay);
  infoSheetParams.opened = false;
}

/**
 * Callback function that is called when a barcode is read.
 * @param {string} code - The code that was read.
 * @returns {Promise<void>}
 */
async function onBarcodeReading(code) {
  if (!lecturaContinuaCargasExpediciones.value) {
    codeScannerRef.value?.ClosePopup();
    const preloaderText = t('codeScanner.info.validatingSerialNumber');
    const cancellationText = t('codeScanner.info.validationCanceled');
    PreloaderGH(true, true, preloaderText, cancellationText);
    const result = await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, false);
    PreloaderGH(false);
    processPaleRead(result);
  } else {
    const result = await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, false);
    processPaleRead(result);
  }
}

/**
 * Callback function that is called when a serial number is read.
 * @param {string} code - The code that was read.
 */
async function onSerialNumberReading(code) {
  if (!lecturaContinuaCargasExpediciones.value) {
    codeScannerRef.value?.ClosePopup();
    const preloaderText = t('codeScanner.info.validatingSerialNumber');
    const cancellationText = t('codeScanner.info.validationCanceled');
    PreloaderGH(true, true, preloaderText, cancellationText);
    const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, false);
    PreloaderGH(false);
    processPaleRead(result);
  } else {
    const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, false);
    processPaleRead(result);
  }
}

/**
 * @param {Respuesta} result
 * @returns {Promise<void>}
 */
async function processPaleRead(result) {
  if (!result.Valor) {
    HiNotification.Alert(result.Mensaje, 'Error');
    return;
  }

  let sameProduct = false;
  const paleLeido = /** @type {UnidadContenedora} */ (JSON.parse(result.Mensaje ?? ''));

  paleLeido.Existencias?.forEach((element) => {
    if (element.Articulo
        && element.Articulo.TipoArticulo === 'Producto'
        && element.Articulo.Id === selectedLine.value.Producto.Id
    ) {
      sameProduct = true;
    }
  });

  if (!sameProduct) {
    ShowInfoPale(false, t('commercialization.expeditionsNoSalesOrder.newCard.info.sameLineArticle'));
    return;
  }

  paleValidation(paleLeido);
}

/**
 * @param {UnidadContenedora} pale
 * @returns {Promise<void>}
 */
async function paleValidation(pale) {
  let movePallet = false;
  let deleteReserves = false;

  if (!lecturaContinuaCargasExpediciones.value) {
    HiDialog.Preloader(true, t('commercialization.info.validatingLoadingPallet'));
  }

  let responseInfoPaleForExpedition = null;
  try {
    responseInfoPaleForExpedition = await APIErp.callInfoStatusXSerialNumberForExpedition(pale.Id);
    HiDialog.Preloader(false);
  } catch {
    HiDialog.Preloader(false);
    if (!lecturaContinuaCargasExpediciones.value) {
      HiNotification.Alert(t('commercialization.info.anErrorHasOccurredQueryingPalletInformation', { pallet: pale.NumeroSerie }));
    }
    return;
  }

  let dataInfoPaleForExpedition = null;
  if (responseInfoPaleForExpedition != null && (responseInfoPaleForExpedition.statusText === 'OK' || responseInfoPaleForExpedition.status === 200)) {
    dataInfoPaleForExpedition = responseInfoPaleForExpedition.data;
  } else {
    if (!lecturaContinuaCargasExpediciones.value) {
      HiNotification.Alert(t('commercialization.info.notPossibleToGetPalletInformationToLoad', { pallet: pale.NumeroSerie }));
    }
    return;
  }

  // 1º - El palé indicado ya está CARGADO en otra orden de carga.
  if (dataInfoPaleForExpedition.CargadoOrdenCarga) {
    const couldNotLoadPalletText = t('commercialization.info.couldNotLoadPalletText', { pallet: pale.NumeroSerie });
    const loadingOrderReservation = `${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}`;
    const palletAlreadyLoadedInOtherLoadingOrder = t('commercialization.info.palletAlreadyLoadedInOtherLoadingOrder', { order: loadingOrderReservation });
    const alertText = `${couldNotLoadPalletText}. ${palletAlreadyLoadedInOtherLoadingOrder}`;
    if (!lecturaContinuaCargasExpediciones.value) {
      const alertTitle = t('common.information');
      HiNotification.Alert(alertText, alertTitle);
    } else {
      ShowInfoPale(false, alertText, 2500);
    }
    return;
  }

  // 2º - El palé indicado ya está RESERVADO en otra orden de carga.
  if (dataInfoPaleForExpedition.ReservadoOrdenCarga) {
    if (!lecturaContinuaCargasExpediciones.value && !permitirMoverPalesReservadosEnOrdenCarga.value) {
      const couldNotLoadPalletText = t('commercialization.info.couldNotLoadPalletText', { pallet: pale.NumeroSerie });
      const loadingOrderReservation = `${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}`;
      const palletIsReservedInLoadingOrder = t('commercialization.info.palletIsReservedInLoadingOrder', { order: loadingOrderReservation });
      const deleteLoadingOrderReservation = t('commercialization.info.deleteLoadingOrderReservation');

      const alertText = `${couldNotLoadPalletText}. ${palletIsReservedInLoadingOrder}. ${deleteLoadingOrderReservation}`;
      const alertTitle = t('common.information');

      HiNotification.Alert(alertText, alertTitle);
    } else if (lecturaContinuaCargasExpediciones.value && !permitirMoverPalesReservadosEnOrdenCarga.value) {
      ShowInfoPale(false, t('commercialization.info.palletNotLoaded', { pallet: pale.NumeroSerie }));
      return;
    }

    if (!permitirMoverPalesReservadosEnOrdenCarga.value) {
      return;
    }

    if (!movePalletFromOtherLoadingOrder.value && !lecturaContinuaCargasExpediciones.value) {
      AskToMovePalletFromOtherLoadingOrder(pale, dataInfoPaleForExpedition);
      return;
    } if (lecturaContinuaCargasExpediciones.value) {
      movePallet = true;
    }
  }

  if (dataInfoPaleForExpedition.PedidoVentaReserva && !deleteReservesPaleFromOtherOrder.value) {
    if (!lecturaContinuaCargasExpediciones.value) {
      if (!eliminarReservaAnteriorExpediciones.value) {
        const salesOrderReservation = `${dataInfoPaleForExpedition.PedidoVentaReserva.Serie}/${dataInfoPaleForExpedition.PedidoVentaReserva.Numero}`;

        const palletIsReservedInSalesOrder = t('commercialization.info.palletIsReservedInSalesOrder', { pallet: pale.NumeroSerie, salesOrder: salesOrderReservation });
        const doYouWantToCancelReservation = t('commercialization.info.doYouWantToCancelReservationNoArguments');

        const actionsToPopover = f7.actions.create({
          buttons: [
            {
              text: `${palletIsReservedInSalesOrder}. ${doYouWantToCancelReservation}`,
              label: true,
            },
            {
              text: t('commercialization.info.deleteReserv'),
              onClick: async () => {
                deleteReservesPaleFromOtherOrder.value = true;
                paleValidation(pale);
              },
            },
            {
              text: t('common.cancel'),
              color: 'red',
            },
          ],
        });
        actionsToPopover.open();
        return;
      } if (eliminarReservaAnteriorExpediciones.value) {
        deleteReservesPaleFromOtherOrder.value = true;
      }
    } else if (eliminarReservaAnteriorExpediciones.value) {
      deleteReserves = true;
    } else {
      ShowInfoPale(false, t('commercialization.info.palletNotLoaded', { pallet: pale.NumeroSerie }));
      return;
    }
  }
  if (lecturaContinuaCargasExpediciones.value) {
    chargePale(pale, movePallet, deleteReserves);
  } else {
    chargePale(pale, movePalletFromOtherLoadingOrder.value, deleteReservesPaleFromOtherOrder.value);
  }
  deleteReservesPaleFromOtherOrder.value = false;
  movePalletFromOtherLoadingOrder.value = false;
  deleteReserves = false;
  movePallet = false;
}

/**
 * @param {UnidadContenedora} pallet
 * @param {{ OrdenCargaReserva: any; }} dataInfoPaleForExpedition
 * @returns {Promise<void>}
 */
async function AskToMovePalletFromOtherLoadingOrder(pallet, dataInfoPaleForExpedition) {
  const loadingOrder = dataInfoPaleForExpedition.OrdenCargaReserva;
  const loadingOrderText = `${loadingOrder.Serie ?? ''}/${loadingOrder.Numero}`;
  const actionsLabel = `${t('commercialization.info.palletIsReservedInLoadingOrder', { order: loadingOrderText })} ${t('commercialization.info.doYouWantToDeleteThisReservation')}. `;
  const actionsInstance = f7.actions.create({
    buttons: [
      {
        text: actionsLabel,
        label: true,
      },
      {
        text: t('common.confirm'),
        onClick: async () => {
          movePalletFromOtherLoadingOrder.value = true;
          paleValidation(pallet);
        },
      },
      {
        text: t('common.cancel'),
        color: 'red',
      },
    ],
  });
  actionsInstance.open();
}

/**
 * @param {UnidadContenedora} pale
 * @param {boolean} movePale
 * @param {boolean} deleteReserves
 * @returns {void}
 */
function chargePale(pale, movePale, deleteReserves) {
  const exists = selectedLine.value.Desglose.some(
    /** @param {Record<string, any>} item */ (item) => !!item.UnidadContenedora && item.UnidadContenedora.Id === pale.Id,
  );

  if (!exists) {
    selectedLine.value.Desglose.push({
      Id: 0,
      Estado: 0,
      MoverPaletsEntreOrdenes: movePale,
      EliminarReservas: deleteReserves,
      UnidadContenedora: pale,
    });
    if (selectedLine.value.Desglose.length > selectedLine.value.CantidadTotalPales) {
      selectedLine.value.CantidadTotalPales += 1;
    }
    ShowInfoPale(true, t('commercialization.expeditionsNoSalesOrder.newCard.info.palletLoaded'));
  } else {
    ShowInfoPale(false, t('commercialization.expeditionsNoSalesOrder.newCard.info.palletAlreadyLoaded'));
  }
}
</script>

<style scoped lang="scss">
.no-sales-order-new-card {
  a {
    padding: calc(var(--f7-typography-padding) / 2);
  }

  &__box {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__content-stepper {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    margin-left: 48px;
    justify-content: center;
    align-items: center;
    width: 125px;
  }

  &__delete {
    flex: 0 0 5%;
    margin-right: calc(var(--f7-typography-padding) / 2);
  }

  &__info {
    flex: 1 0 65%;

    &__client {
      color: var(--ae-darkblue);
    }

    &__address {
      font-size: 14px;
      color: var(--his-oliva);
    }

    &__article {
      font-size: 14px;
      color: var(--his-mandarina);
    }
  }

  &__qr {
    flex: 0 0 10%;
  }

  &.accordion-item {
    border-bottom: 0;
    border: 0.5px solid var(--hi-silver);
    border-radius: 6px;
    margin-bottom: 10px;
  }

  .content-pallets {
    --f7-list-item-title-text-color: var(--ae-darkblue);
    --f7-list-bg-color: var(--his-tierra-white);

    li {
      padding-left: calc(var(--f7-typography-padding) * 2);
      padding-right: calc(var(--f7-typography-padding) * 2);
    }
  }

  .item-content-after {
    color: var(--ae-darkblue);
    padding-left: 20px;
    background: #ebefef;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 32px;
  }
}
</style>
